import {
  ADMIN_FINANCIAL_PRODUCT_READ,
  ADMIN_FINANCIAL_PRODUCT_WRITE,
  ADMIN_LEASING_INCOME_SCHEMAS_READ,
  ADMIN_LEASING_INCOME_SCHEMAS_WRITE,
  ADMIN_RESIDUAL_VALUE_GRIDS_READ,
  ADMIN_RESIDUAL_VALUE_GRIDS_WRITE,
  ADMIN_GENERIC_ENTITY_FLOW_CHECKLIST
} from 'constants/rightsCodes';

export const entityContextPath = {
  CHECKLIST: 'genericEntityFlowChecklist',
  FINANCIAL_PRODUCT: 'genericEntityFlowFinancialProduct',
  GENERIC_MATRIX: 'genericEntityFlowGenericMatrix',
  GENERIC_MATRIX_TEMPLATE: 'genericEntityFlowGenericMatrixTemplate',
  INCOME_SCHEMA: 'genericEntityFlowIncomeSchema',
  RESIDUAL_VALUE_GRID: 'genericEntityFlowResidualValueGrid',
  SUBSIDY_MATRIX: 'genericEntityFlowSubsidyMatrix'
};

export const entityContextPermissions = {
  CHECKLIST: { read: [ADMIN_GENERIC_ENTITY_FLOW_CHECKLIST], write: [ADMIN_GENERIC_ENTITY_FLOW_CHECKLIST] },
  FINANCIAL_PRODUCT: { read: [ADMIN_FINANCIAL_PRODUCT_READ], write: [ADMIN_FINANCIAL_PRODUCT_WRITE] },
  GENERIC_MATRIX: { read: [], write: [] },
  GENERIC_MATRIX_TEMPLATE: { read: [], write: [] },
  INCOME_SCHEMA: { read: [ADMIN_LEASING_INCOME_SCHEMAS_READ], write: [ADMIN_LEASING_INCOME_SCHEMAS_WRITE] },
  RESIDUAL_VALUE_GRID: { read: [ADMIN_RESIDUAL_VALUE_GRIDS_READ], write: [ADMIN_RESIDUAL_VALUE_GRIDS_WRITE] },
  SUBSIDY_MATRIX: { read: [], write: [] }
};
